var map = {
	"./en/hotel.json": [
		115,
		11
	],
	"./ja/hotel.json": [
		116,
		10
	],
	"./ko/hotel.json": [
		117,
		9
	],
	"./zh-CN/hotel.json": [
		118,
		8
	],
	"./zh-TW/hotel.json": [
		119,
		7
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
module.exports = webpackAsyncContext;
webpackAsyncContext.id = 10;


//////////////////
// WEBPACK FOOTER
// ./public/locales lazy ^\.\/.*\/hotel\.json$
// module id = 10
// module chunks = 93 95 97 98 99 100 101 102